import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import * as ErrorUtils from '@/checkout-instore-legacy/utils/ErrorUtils'
import Button from '@/checkout-instore-legacy/components/Commons/Elements/Button'

export default function ProductPageError({ error, onRetry, onRemove }) {
  return (
    <div
      id="ProductPageError"
      className="flex flex-column vh-100 justify-center align-center"
    >
      <div className="flex flex-column align-center justify-center w-50 center">
        <div className="text-muted tc">
          <FormattedMessage id="productErrorPageLabel" />
        </div>

        <div className="error-items tc pv6">
          <div className="error-item">{ErrorUtils.getErrorMessage(error)}</div>
        </div>

        <div className="flex justify-center tc center">
          <Button id="refresh-product" onClick={onRetry} kind="info">
            <FormattedMessage id="productErrorPageRetry" />
          </Button>
          <Button
            id="refresh-product"
            onClick={onRemove}
            kind="light-danger"
            className="mh6"
          >
            <FormattedMessage id="productErrorPageRemoveFromCart" />
          </Button>
        </div>
      </div>
    </div>
  )
}

ProductPageError.propTypes = {
  error: PropTypes.object,
  onRetry: PropTypes.func,
  onRemove: PropTypes.func,
}
